module.exports = __webpack_public_path__ + "img/anquan.6143477d.png";